import { createContext, useContext, useState } from 'react';
import type { ReactNode } from 'react';

// Replaces the setName prop that used to be threaded from components/Main.jsx
// down through <Route> elements into Team.jsx, Person.jsx, Tournament.jsx and
// Game.jsx. Those 4 screens call setPageTitle() with the entity's display name
// once it loads; ContentLayout reads pageTitle back out and forwards it to
// RecentlyViewed as its `name` prop (unchanged behavior -- see ContentLayout.jsx).
interface PageTitleContextValue {
    pageTitle: string;
    setPageTitle: (title: string) => void;
}

const PageTitleContext = createContext<PageTitleContextValue | undefined>(undefined);

export function PageTitleProvider({ children }: { children: ReactNode }) {
    const [pageTitle, setPageTitle] = useState('');
    return (
        <PageTitleContext.Provider value={{ pageTitle, setPageTitle }}>
            {children}
        </PageTitleContext.Provider>
    );
}

export function usePageTitle(): PageTitleContextValue {
    const ctx = useContext(PageTitleContext);
    if (!ctx) {
        throw new Error('usePageTitle must be used within a <PageTitleProvider>');
    }
    return ctx;
}
